import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import Page403 from '../../pages/errors/403-page';
import BaseLayout from '../../layouts/base-layout';

// ----------------------------------------------------------------------

const Page404 = lazy(() => import('../../pages/errors/404-page'));

// ----------------------------------------------------------------------

export const baseRoutes = [
  {
    element: (
      <BaseLayout>
        {/* TODO: implement nicer loading screen for fallback */}
        <Suspense fallback={<></>}>
          <Outlet />
        </Suspense>
      </BaseLayout>
    ),
    children: [
      { path: '404', element: <Page404 /> },
      {
        path: '403',
        element: <Page403 />,
      },
    ],
  },
];
